export default __webpack_public_path__ + "static/media/notification-button-arrow-white.b24ce8c5.svg";